import DOMPurify from 'dompurify';

if (window.trustedTypes && window.trustedTypes.createPolicy) {
  // Feature testing
  window.trustedTypes.createPolicy('default', {
    // ProseMirror/TipTap tables carry column widths in a non-standard `colwidth`
    // attribute, which DOMPurify strips by default. Since this default policy runs
    // on every paste (ProseMirror routes clipboard HTML through createHTML), that
    // silently collapses pasted table columns to equal widths. `colwidth` is a
    // comma-separated pixel list — no script/URL vector — so it is safe to keep.
    createHTML: (string) =>
      DOMPurify.sanitize(string, {
        RETURN_TRUSTED_TYPE: true,
        ADD_ATTR: ['colwidth'],
      }),
    createScriptURL: (string) => string, // warning: this is unsafe!
    createScript: (string) => string, // warning: this is unsafe!
  });
}
